import { useHandlerDebounced } from 'labguard-cdk'
import React from 'react'

/**
 * Provide the measurements of the selected channel and period
 *
 * /!\ uses raw fetch instead of Apollo because of performance issues
 */
export default function useMeasurements({ channelId, from, to }) {
  const [state, setState] = React.useState({ loading: false })

  const fetchMeasurements = useHandlerDebounced(200)(() =>
    fetch('/graphql', {
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        variables: { channelId, period: { to, from } },
        query: `
        query measurements($channelId: ID!, $period: PeriodInput!) {
            channel(id: $channelId) {
              measurements(period: $period) {
                data {
                  date
                  value
                  origin
                }
              }
            }
          }
    `,
      }),
      method: 'POST',
      mode: 'cors',
    })
      .then(res => res.json())
      .then(({ data: { channel: { measurements = [] } = {} } = {} }) =>
        setState({
          loading: false,
          // convert strings to real date objects
          data: measurements.map(serie => ({
            ...serie,
            data: serie.data.map(m => ({ ...m, date: new Date(m.date) })),
          })),
        })
      )
  )

  React.useEffect(
    () => {
      if (!state.loading) setState(s => ({ ...s, loading: true }))
      fetchMeasurements()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [channelId, from, to]
  )

  return state
}
